import { useState, useEffect } from 'react'
import { useEmailConfirmationAPI } from '../../../hooks/use-emailConfirmation-api/useEmailConfirmationAPI'
import { useHistory, useLocation } from 'react-router-dom'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useLocalStorage } from 'hooks/use-local-storage/useLocalStorage'

import moment from 'moment'

export const useEmailConfirmation = () => {
  const { confirmEmail, resendConfirmationCode } = useEmailConfirmationAPI()
  const history = useHistory()
  const { clearUser, backendUser, forwardingUrl } = useAuth()
  const { pathname } = useLocation()
  const { setItem, getItem, clearItem } = useLocalStorage()
  const [showConfirmEmailModal, setShowConfirmEmailModal] = useState(false)
  const [success, setSuccess] = useState(false)
  const [errorCount, setErrorCount] = useState(0)
  const [errorFlag, setErrorFlag] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [timer, setTimer] = useState(90000)
  const partnerRegistrationPathname = ['/register']

  useEffect(() => {
    if (getItem('browserClosed') === 'true') {
      setTimer(0)
      setErrorCount(errorCount + 1)
      setErrorFlag(true)
      setErrorMessage('Code Expired')
    }
  }, [timer, backendUser])

  const confirmUser = async (confirmationCode: string) => {
    try {
      
      await confirmEmail(backendUser?.id, confirmationCode)

      backendUser.enabled = true
      setSuccess(true)
      setShowConfirmEmailModal(false)

      // If the user isn't onboarded
      if (partnerRegistrationPathname?.includes(pathname)) {
        history.push(forwardingUrl ? forwardingUrl?.url : '/settings')
      } else if (!backendUser.isOnBoarded) {
        history.push('/settings')
      }
    } catch (err) {
      if (err.includes('Code has expired')) {
        setErrorMessage('Code Expired')
        setErrorFlag(true)
      } else if (err && !err.includes('Code has expired')) {
        setErrorFlag(true)
        setErrorCount(errorCount + 1)
      }

      if (errorCount === 2) {
        clearUser()
        setShowConfirmEmailModal(false)
        setErrorMessage('')
        setErrorCount(0)
        setSuccess(true)
      }
    }
  }

  const countdown = time => {
    return moment.utc(time).format('mm:ss')
  }

  return {
    countdown,
    showConfirmEmailModal,
    setShowConfirmEmailModal,
    success,
    setSuccess,
    errorCount,
    setErrorCount,
    errorFlag,
    setErrorFlag,
    errorMessage,
    setErrorMessage,
    confirmUser,
    timer,
    setTimer,
    resendConfirmationCode,
    setItem,
    getItem,
    clearItem
  } as const
}
